// src/components/ProductSelectorInput.js
import React, { forwardRef, useState, useMemo } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { useAllProducts } from '../hooks/useAllProducts';

export const ProductSelectorInput = forwardRef(({
  id = 'product',
  query,               // string shown in the input
  onQueryChange,       // called when typing/clearing
  onSelect,
  isdisabled,
  placeholder = 'Select product...',
  lazy = false,        // when true, defer loading the product catalog until the user first focuses this field
}, ref) => {
  const [touched, setTouched] = useState(!lazy);
  const { data: products = [], isLoading } = useAllProducts({ enabled: touched });
  const [filtered, setFiltered] = useState([]);

  const list = useMemo(() =>  products, [products]);

  const search = (e) => {
    const q = (e.query || '').toLowerCase().trim();
    setFiltered(
      list.filter(p => p.nameLower.includes(q) || p.codeLower.includes(q)).slice(0, 20)
    );
  };

  return (
    <AutoComplete
      id={id}
      ref={ref}
      value={query}                 // keep typing visible
      suggestions={filtered}
      completeMethod={search}
      field="name"                  // input shows ONLY the name
      disabled={isLoading || isdisabled}
      placeholder={placeholder}
      onFocus={() => setTouched(true)}
      onChange={(e) => {
        const val = e.value;
        if (val && typeof val === 'object') {
          // user picked an object from the list
          onSelect(val);
          onQueryChange(val.name);
        } else {
          // user typed or cleared
          onSelect(null);
          onQueryChange(val);
        }
      }}
      itemTemplate={(item) => (
        <div className="flex items-center">
          <span>{item.name}</span>
          {item.code ? <span className="ml-2 text-500 text-xs">({item.code})</span> : null}
        </div>
      )}
      className="w-full"
      style={{ minWidth: '140px', width: '100%' }}
      inputStyle={{ width: '100%' }}
    />
  );
});
